<template>
    <input-group icon='fas fa-plane-arrival'>
        <v-select class='form-control'
            v-model="selectedValue"

            :options="availableConditions"
            :disabled="!canWrite || availableConditions.length === 0"
            :clearable="false"
            
            label='name'

            searchable
            filterable
            taggable

            close-on-select
        >
            <div slot='no-options' />
        </v-select>
    </input-group>
</template>

<script>

import guid from '../../../../../../Util/Mixins/guid';
import resources from '../../../../../../Util/Mixins/resources';
import permissionsMixin from '../../../../Mixins/journey-permissions';

import InputGroup from '../../../../../../Components/Inputs/InputGroup.vue';
import VSelect from 'vue-select';

export default {
    name: 'touchpoint-arrival',
    components: {
        VSelect,
        InputGroup
    },
    mixins: [resources, guid, permissionsMixin],
    created() {
        const vm = this;
        vm.selectedValue = vm.availableConditions.find(v => v.id === vm.value) || '';
    },
    watch: {
        selectedValue(value){
            this.$emit('input', value ? value.id : '');
        },
        availableConditions(value) {
            const valueAvailable = value.indexOf(this.selectedValue) !== -1;
            
            if(!valueAvailable) {
                this.selectedValue = null;
            }
        }
    },
    data() {
        return {
            selectedValue: null,
            elementName: 'Arrival'
        }
    },
    props: {
        value: {
            type: String,
            default: null
        },
        availableConditions: {
            type: Array,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>

</style>